import _ from "lodash";

export const getWrapClass = (regime, header) => {
  let classString = "";
  classString += header ? "active " : "";
  classString += regime === "account" ? "account" : "";
  return classString;
};

export const excludedMealsInBasket = (selectedExl, selectedItems) => {
  const meals = _.concat(selectedItems.breakfasts, selectedItems.entrees);
  let flag = false;
  meals.forEach((meal) => {
    meal.tags.forEach((tag) => {
      selectedExl.forEach((exclusion) => {
        const exclusionName = exclusion.toLowerCase();
        const tagName = tag.toLowerCase();

        if (tagName.includes(exclusionName)) flag = true;
      });
    });
  });
  return flag;
};
